<div class="fields">
  @if (lineChartDialogData().parentUrl === 'month-reports' || lineChartDialogData().parentUrl ===  'article-month-reports') {
    <mat-form-field
      appearance="outline"
      class="mat-form-field"
    >
      <mat-label>Год</mat-label>
      <input
        matInput
        type="number"
        [(ngModel)]="selectedYear"
        (blur)="handleSelectChange()"
        (keydown.enter)="handleSelectChange()"
      >
    </mat-form-field>
  } @else {
    <mat-form-field
      appearance="outline"
      class="date-wrapper"
    >
      <mat-label>Период</mat-label>
      <mat-date-range-input
        [formGroup]="rangeForm"
        [rangePicker]="picker"
      >
        <input
          #dateRangeStart
          matInput
          matStartDate
          appDateInput
          placeholder="Начальная"
          formControlName="dateFrom"
        >
        <input
          #dateRangeEnd
          matInput
          matEndDate
          appDateInput
          placeholder="Конечная"
          formControlName="dateTo"
          (dateChange)="handleDateRangeChange(dateRangeStart.value, dateRangeEnd.value)"
        >
      </mat-date-range-input>
      <div class="toggle">
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-datepicker-toggle
          matSuffix
          (click)="clearDateRange()"
        >
          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
        </mat-datepicker-toggle>
      </div>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  }

  @if (isArticleReports()) {
    <mat-form-field
      appearance="outline"
      class="mat-form-field"
    >
      <mat-label>Артикул</mat-label>
      <mat-select
        [(ngModel)]="selectedArticleId"
        (selectionChange)="handleSelectChange()"
      >
        @for (option of selectArticleData; track $index) {
          <mat-option [value]="option.id">
            {{ option.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  } @else {
    <mat-form-field
      appearance="outline"
      class="mat-form-field"
    >
      <mat-label>Продукт</mat-label>
      <mat-select
        [(ngModel)]="selectedProductId"
        (selectionChange)="handleSelectChange()"
      >
        @for (option of selectProductsData; track $index) {
          <mat-option [value]="option.id">
            {{ option.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <mat-form-field
    appearance="outline"
    class="mat-form-field"
  >
    <mat-label>Колонки</mat-label>
    <mat-select
      multiple
      [(ngModel)]="selectedColumns"
      (selectionChange)="handleSelectChange()"
    >
      <mat-checkbox
        [checked]="isAllSelected()"
        (change)="toggleSelectAll()"
      >
        {{ isAllSelected() ? 'Снять все' : 'Выбрать все' }}
      </mat-checkbox>
      <mat-divider></mat-divider>
      @for (option of columnsSelectData; track $index) {
        <mat-option [value]="option.key">
          {{ option.value }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
